document.addEventListener("DOMContentLoaded", function () {
  const years = document.querySelectorAll(".timeline-year");
  const items = document.querySelectorAll(".timeline-item");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const activeYear = entry.target.id.split("-")[1];
          years.forEach((year) => {
            year.classList.toggle("active", year.dataset.year === activeYear);
          });
        }
      });
    },
    {
      threshold: 0.5, // Zorgt ervoor dat een item actief wordt zodra 50% zichtbaar is
    }
  );

  items.forEach((item) => observer.observe(item));

  years.forEach((year) => {
    year.addEventListener("click", () => {
      const target = document.getElementById(`year-${year.dataset.year}`);
      target.scrollIntoView({ behavior: "smooth" });
    });
  });
});
